export default "__VITE_ASSET__844ebf06__"